import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { DatesProvider } from '@mantine/dates';

const App = lazy(() => import('./AppRoutes'));

const AppSuspense = () => {
  const { i18n } = useTranslation();

  if (!i18n.isInitialized) {
    return null;
  }

  return (
    <DatesProvider settings={{ locale: i18n.language }}>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </DatesProvider>
  );
};

export default AppSuspense;
